import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _ from 'lodash';
import { of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { Instance } from '../../../models';
import { InstanceMonitoringService } from '../../../services/instance-monitoring.service';
import { ProcessService } from '../../../services/process.service';
import IInstance = ZoningAPI.IInstance;

@Component({
    standalone: false,
    selector: 'tr[app-i-m-last-updated-row]',
    templateUrl: './i-m-last-updated-row.component.html',
    styleUrls: [
        './i-m-last-updated-row.component.scss',
        '../i-m-unsynchronized-cr-group-ids-row/i-m-unsynchronized-cr-group-ids-row.component.scss'
    ]
})
export class IMLastUpdatedRowComponent implements OnInit {
    @Input()
    instance: Instance;

    @Output()
    actionPerformed = new EventEmitter<boolean>();

    constructor(
        private readonly instanceMonitoringService: InstanceMonitoringService,
        private readonly snackBar: MatSnackBar,
        private readonly processService: ProcessService,
        private readonly dialog: MatDialog
    ) {}

    get needFix(): boolean {
        return !_.get(this, 'instance.isRecentlyOptimized');
    }

    get canStart(): boolean {
        return this.instance && !this.instance.IsOptimizationRunning;
    }

    ngOnInit(): void {}

    fix() {
        if (!this.canStart) {
            return of(null);
        }
        if (this.processService.activeProcessesCount) {
            this.openActionNotAllowedDialog();
            return of(null);
        }
        return this.instanceMonitoringService.runOptimization(this.instance.Id).pipe(
            map((instanceData: IInstance) => {
                this.instance.initWithJSON(instanceData);
                if (instanceData && instanceData.Name) {
                    this.snackBar.open(
                        `${instanceData.Name} (${instanceData.State}) database optimization started.`,
                        'OK',
                        {
                            verticalPosition: 'top',
                            horizontalPosition: 'center',
                            duration: 4000
                        }
                    );
                }
            })
        );
    }

    private openActionNotAllowedDialog() {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            title: 'Start database optimization',
            topContent: 'The processes are in progress.',
            bottomContent: 'Please stop all processes before start optimization',
            okButtonColor: 'warn',
            hideYesButton: true,
            hideNoButton: true,
            showCancelButton: true
        };

        const dialog = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
        dialog
            .afterClosed()
            .pipe(filter(isConfirm => isConfirm))
            .subscribe(() => {});
    }
}
